import React from 'react';
import { portal, Portal } from '../../../Configs/general';
import ContributionExemptionGDC from './ContributionExemption.GDC';

const ContributionExemption = props => {
  switch (portal) {
    case Portal.Gascaribe:
      return <ContributionExemptionGDC {...props} />;
    default:
      return <></>;
  }
};

export default ContributionExemption;
